import renameThumbnailsForm from 'a_root-folder/lib/service/modal/templates/renameThumbnails';
import HelpService from "a_root-folder/lib/service/help.service";
import {STATIC_DOMAIN} from "a_root-folder/lib/e3plan-3d/modules/constants";

export default class Thumbnails{
    constructor(modalService, translate) {
        this._modalService =  modalService;
        this._translate =  translate;
        this._helperService = new HelpService();
    }

    hide() {
        if (this._modalService.checkIfModalPresent('lead-generation')) {
            this._modalService._removeModal('lead-generation');
        }
    }

    rename(name) {
        return new Promise((res, rej) => {
            try{
                this._modalService.showCreatedModal('rename-thumbnail', renameThumbnailsForm(this._translate, name, (e, data) => {
                    res({e, data});
                    this._modalService._removeModal('rename-thumbnail');
                }), true);
            }catch (e){
                rej(e)
            }
        })
    }
}
